import { createTheme } from '@mui/material';

// Dark theme with blue accents, pour l'app grand public (App.js).
// L'Admin CMS est une app autonome separee (admin/, Vite + shadcn).
const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,    // Phone portrait (iPhone 15 = 393px) — baseline
      sm: 600,  // Phone landscape / small tablet
      md: 1024, // Desktop / large tablet (raised from MUI default 900)
      lg: 1200,
      xl: 1536,
    },
  },
  palette: {
    mode: 'dark',
    primary: {
      main: '#6c95dc', // Bleu glacier, meme valeur que --accent dans index.css
      light: '#8fb0e6',
      dark: '#4a72b8',
    },
    secondary: {
      main: '#f50057', // Pink accent for scale type tabs
    },
    background: {
      default: '#000000', // Pure black background

    },
    text: {
      primary: '#ffffff',
      secondary: 'rgba(255, 255, 255, 0.7)',
    },
  },
  typography: {
    fontFamily: "'DM Sans', 'Helvetica', 'Arial', sans-serif",
    h5: {
      fontWeight: 300,
      letterSpacing: '0.5px',
      fontSize: '1.7rem',
    },
    h6: {
      fontWeight: 600,
      letterSpacing: '-0.5px',
      fontSize: '1.5rem',
      color: '#FFFFFF',
    },
    body1: {
      fontWeight: 300,
      fontSize: '1.1rem',
    },
    body2: {
      fontWeight: 300,
      fontSize: '1rem',
    },
    caption: {
      fontSize: '0.9rem',
    },
    button: {
      fontSize: '1rem',
      fontWeight: 400,
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
        },
        containedPrimary: {
          backgroundColor: 'var(--button)',
          color: 'var(--button-text)',
          '&:hover': { backgroundColor: 'var(--button-hover)' },
        },
      },
    },
  },
});

export default theme;
